import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import HistoryHourMeter from './history.components/HistoryHourMeter';
import HistoryStartDate from './history.components/HistoryStartDate';
import HistoryVoltageLogs from './history.components/HistoryVoltageLogs';
import HistoryFaultLogs from './history.components/HistoryFaultLogs';
import HistorySNWifiRF from './history.components/HistorySNWifiRF';
import HistorySNWifiR2 from './history.components/HistorySNWifiR2';
import { MainRfContext } from '../context/MainRfContext';
import { MainContext } from '../context/MainContext';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

function HistoryContent() {
  const state = useContext(MainRfContext);
  if ((state.selectedDevice === 0)) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert variant="filled" severity="error">
          No spa associated with this account
        </Alert>
      </Stack>
    </Container>)
  } else if (!state.R2 || !state.RG) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Stack sx={{ width: '100%', pt: 2, pl: 3 }} spacing={2}>
        <Alert variant="filled" severity="error">
          No RF Data Available
        </Alert>
      </Stack>
    </Container>)
  } else {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <MainContext.Provider value={{ state }}>
          <Grid container spacing={3}>
            {/* Offline alert */}
            {state.online === false && (
              <Grid item xs={12}>
                <Stack spacing={2}>
                  <Alert variant="filled" severity="error">
                    Spa is Offline
                  </Alert>
                </Stack>
              </Grid>
            )}

            <Grid item xs={12} md={6} lg={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, height: '100%' }}>
                    <HistoryHourMeter />
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Paper sx={{ p: 2, height: '100%' }}>
                    <HistoryStartDate />
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Paper sx={{ p: 2, height: '100%' }}>
                    <HistoryVoltageLogs />
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <HistoryFaultLogs />
              </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Paper sx={{ p: 2, height: '100%' }}>
                <HistorySNWifiRF />
              </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Paper sx={{ p: 2, height: '100%' }}>
                <HistorySNWifiR2 />
              </Paper>
            </Grid>
          </Grid>
        </MainContext.Provider>
        <Copyright sx={{ pt: 4 }} />
      </Container>
    );
  }
}

export default function History() {
  return <HistoryContent />;
}